// Mod_Door.ts — the Door modifier (Buildings Set1, §2.5).
//
// A Door is an opening in a wall of the closest ancestor Room, always at floor level (the sill is
// at the floor slab top). `swing` decides the hinge stile + whether the slab is flush with the
// inner or outer face; `openAngle` makes the swing visibly meaningful.
import {BuildingMaterials, DoorSwing} from "./Building/BuildingShared.js";

export class Mod_Door {
	constructor(data?: Partial<Mod_Door>) { Object.assign(this, data); }
	width?: number|n;
	height?: number|n;            // sill is always at floor level for doors
	swing?: DoorSwing|n;
	/** 0 = closed. Included so `swing` is visibly meaningful; hinge side + push direction both
	 *  come from `swing`. */
	openAngle?: number|n;
	materials?: n|BuildingMaterials;
}
